"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var PaginatorWrapper = function PaginatorWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "selectedPage", _descriptor, _this);
      _initializerDefineProperty(_this, "showSpinner", _descriptor2, _this);
      _this.afterIncrementPage = function (resp) {
        var _this$props$onPageLoa, _this$props;
        _this.showSpinner = false;
        if (_this.props.store) {
          _this.props.store.afterGetIndex(resp);
        }
        (_this$props$onPageLoa = (_this$props = _this.props).onPageLoaded) === null || _this$props$onPageLoa === void 0 || _this$props$onPageLoa.call(_this$props);
        if (_this.props.onClickScrollToTop && !_state.AppUI.layout.isNative) {
          _state.AppUI.scrollToPageTop('smooth', _this.props.pageTop);
        }
      };
      _this.onPageIncremented = function (increment) {
        if (_this.props.withSpinner) {
          _this.showSpinner = true;
        }
        if (_this.props.onPagination) {
          _this.props.onPagination(increment);
          if (_this.props.onClickScrollToTop && !_state.AppUI.layout.isNative) {
            _state.AppUI.scrollToPageTop('smooth', _this.props.pageTop);
          }
        }
        _this.selectedPage = null;
        var nextPage = parseInt(_this.derivedPage, 10) + increment;
        if (_this.props.updateUrl) {
          _this.setUrl(nextPage);
        }
        if ((0, _utils.isPresent)(_this.props.store) && (!_this.totalCount || nextPage <= _this.pagesCount) && (!_this.props.maxPage || nextPage <= _this.props.maxPage) && increment === 1 && !_this.isLastPage || increment === -1 && !_this.isFirstPage) {
          var _this$props$store;
          if (_this.props.clearOnPagination) {
            _this.props.store.resetIndexDataArray();
          }
          (_this$props$store = _this.props.store) === null || _this$props$store === void 0 || _this$props$store.incrementPage(increment, {
            ids: _this.props.ids,
            queryStrings: _this.props.queryStrings,
            filters: _this.props.filters,
            callback: _this.afterIncrementPage
          });
        }
      };
      _this.onSetPage = function (value) {
        _this.selectedPage = value;
      };
      _this.onSubmitPage = function () {
        var updatedPage = parseInt(_this.selectedPage, 10);
        if (_this.props.withSpinner) {
          _this.showSpinner = true;
        }
        if (_this.props.updateUrl) {
          _this.setUrl(updatedPage);
        }
        if (updatedPage > 0 && updatedPage <= _this.pagesCount && _this.props.store) {
          if (_this.props.clearOnPagination) {
            _this.props.store.resetIndexDataArray();
          }
          _this.props.store.setPage(updatedPage);
          _this.props.store.reloadIndexFiltered({
            ids: _this.props.ids,
            queryStrings: _this.props.queryStrings,
            filters: _this.props.filters,
            callback: _this.afterIncrementPage
          });
        }
      };
      _this.onNavigateToPage = function (pageNumber) {
        var updatedPage = parseInt(pageNumber, 10);
        if (Number.isNaN(updatedPage) || updatedPage === parseInt(_this.derivedPage, 10)) {
          return;
        }
        if (_this.props.withSpinner) {
          _this.showSpinner = true;
        }
        if (_this.props.onPagination) {
          _this.props.onPagination(updatedPage - parseInt(_this.derivedPage, 10));
          if (_this.props.onClickScrollToTop && !_state.AppUI.layout.isNative) {
            _state.AppUI.scrollToPageTop('smooth', _this.props.pageTop);
          }
        }
        _this.selectedPage = null;
        if (_this.props.updateUrl) {
          _this.setUrl(updatedPage);
        }
        if (updatedPage > 0 && updatedPage <= _this.pagesCount && _this.props.store) {
          if (_this.props.clearOnPagination) {
            _this.props.store.resetIndexDataArray();
          }
          _this.props.store.setPage(updatedPage);
          _this.props.store.reloadIndexFiltered({
            ids: _this.props.ids,
            queryStrings: _this.props.queryStrings,
            filters: _this.props.filters,
            callback: _this.afterIncrementPage
          });
        }
      };
      _this.setUrl = function (page) {
        var url = window.location.href;
        var ary = url.split('/page/');
        var newUrl = "".concat(ary[0], "/page/").concat(page);
        _state.AppUI.routeStore.updateUrl(newUrl);
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "derivedPage",
      get: function get() {
        var _this$props$store2;
        return (0, _utils.isPresent)(this.props.currentPage) ? this.props.currentPage : (_this$props$store2 = this.props.store) === null || _this$props$store2 === void 0 ? void 0 : _this$props$store2.page;
      }
    }, {
      key: "selectedPageIsNotSubmitted",
      get: function get() {
        return (0, _utils.isPresent)(this.selectedPage) && this.derivedPage !== this.selectedPage;
      }
    }, {
      key: "page",
      get: function get() {
        return this.selectedPage === null ? this.props.currentPage || this.derivedPage : this.selectedPage;
      }
    }, {
      key: "isLastPage",
      get: function get() {
        if (this.pagesCount && this.derivedPage) {
          return parseInt(this.derivedPage, 10) === parseInt(this.pagesCount, 10);
        }
        if (this.props.store) {
          return !this.props.store.hasIndexData || this.props.store.indexData.length < this.props.store.limit;
        }
      }
    }, {
      key: "isFirstPage",
      get: function get() {
        return parseInt(this.derivedPage, 10) === 1;
      }
    }, {
      key: "totalCount",
      get: function get() {
        var _this$props$store3;
        return this.props.totalCount || ((_this$props$store3 = this.props.store) === null || _this$props$store3 === void 0 ? void 0 : _this$props$store3.totalCount);
      }
    }, {
      key: "pagesCount",
      get: function get() {
        var _this$props$store4;
        if ((0, _utils.isPresent)(this.totalCount) || ((_this$props$store4 = this.props.store) === null || _this$props$store4 === void 0 ? void 0 : _this$props$store4.pagesCount) > 0) {
          var _this$props$store5, _this$props$store6;
          return this.totalCount ? Math.ceil(this.totalCount / (this.props.limit || ((_this$props$store5 = this.props.store) === null || _this$props$store5 === void 0 ? void 0 : _this$props$store5.limit))) : (_this$props$store6 = this.props.store) === null || _this$props$store6 === void 0 ? void 0 : _this$props$store6.pagesCount;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          onPageIncremented: this.onPageIncremented,
          onSetPage: this.onSetPage,
          setUrl: this.setUrl,
          page: this.page,
          isLastPage: this.isLastPage,
          isFirstPage: this.isFirstPage,
          selectedPageIsNotSubmitted: this.selectedPageIsNotSubmitted,
          onSubmitPage: this.onSubmitPage,
          onNavigateToPage: this.onNavigateToPage,
          totalCount: this.totalCount,
          pagesCount: this.pagesCount,
          derivedPage: this.derivedPage,
          showSpinner: this.showSpinner
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selectedPage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "derivedPage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "derivedPage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedPageIsNotSubmitted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedPageIsNotSubmitted"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "page", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "page"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isLastPage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isLastPage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isFirstPage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isFirstPage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "totalCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "totalCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pagesCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pagesCount"), _class2.prototype), _class2)) || _class;
};
PaginatorWrapper.displayName = 'PaginatorWrapper';
var _default = exports["default"] = PaginatorWrapper;